import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { Tooltip } from '@alfa-bank/site-tooltip-v2';
import { NamedContainer } from '@alfa-bank/site-named-container';

import { HintIcon } from './hint-icon';
import type { IHintProps } from './models';
import styles from './styles.css';

export const HintDesktop: FC<IHintProps> = ({
    className,
    content,
    iconClassName,
    iconFill,
    iconSize,
    restrictPopoverWidth = true,
}) => {
    if (!content) {
        return null;
    }

    return (
        <Tooltip
            className={cn(styles.external, styles.hintWrapper, className)}
            popoverClassName={cn(styles.external, { [styles.popover]: restrictPopoverWidth })}
            position="top"
            tag="div"
            targetClassName={cn(styles.external, styles.hint)}
            trigger="click"
            view="tooltip"
        >
            <NamedContainer name="content">{content}</NamedContainer>
            <HintIcon className={iconClassName} fill={iconFill} size={iconSize} />
        </Tooltip>
    );
};
